import { _delete, _get, _post, _put } from "lib/rest";

type projectQueryType = {
  name: string;
  category?: string;
  analyzed_at?: string;
};

/*
*
* 필터링과 정렬 기능 개선 했습니다.
ㅇ 카테고리 필터링: category 파라미터를 콤마(,)로 구분하여 입력
예제:
CAR, FASHION 필터링: https://api.onmydev.com:8000/sentiment/project/?category=CAR,FASHION
ㅇ 정렬 기능: ordering 파라미터에 해당 필드명을 입력
정렬 가능 필드: id, name, created_at, category, analyzed_at
정렬 순서
+필드명: 오름차순 (기본값)
-필드명: 내림차순
예제:
이름 오름차순: https://api.onmydev.com:8000/sentiment/project/?ordering=name
이름 내림차순: https://api.onmydev.com:8000/sentiment/project/?ordering=-name
*
* */
export const getProjectList = async (data?: {
  category?: string;
  ordering?: string;
}) => await _get("/sentiment/project/", data);
export const getProject = async (pid: number) =>
  await _get(`/sentiment/project/${pid}/`);
export const createProject = async ({
  name,
  category = "GENERAL",
  analyzed_at,
}: projectQueryType) =>
  await _post("/sentiment/project/", {
    name,
    category,
    analyzed_at,
  });

export const updateProject = async (pid: number, data: projectQueryType) =>
  await _put(`/sentiment/project/${pid}/`, data);
export const deleteProject = async (pid: number) =>
  await _delete(`/sentiment/project/${pid}/`);

//카테고리 가져오기
export const getCategory = async () =>
  await _get("/sentiment/project/category/");
export const getCategoryDetail = async ({ category }: { category: string }) =>
  await _post("/sentiment/project/category/", { category });

//카테고리 추가요청리스트
export const getCategoryRequestList = async () =>
  await _get("/sentiment/request/category/");
//카테고리 추가요청
export const requestCategory = async (data: {
  name: string;
  description: string;
  result?: string;
}) => await _post("/sentiment/request/category/", data);
